import React, { Component } from 'react'
import { observer } from 'mobx-react';
import { Button, InputNumber, Icon, message } from "utils/ui";
import { updateUserBirthday } from "../api_calls/user";
@observer(["AuthStore", "UserStore"])
class WelcomeModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            submitButton: <Button onClick={this.onSubmitClicked.bind(this)} size="large">Submit birth info and agree to terms</Button>,
            birthMonth: 0,
            birthDay: 0,
            disabled: false
        }
        this.onDayChange = this.onDayChange.bind(this);
        this.onMonthChange = this.onMonthChange.bind(this);
        this.onSubmitClicked = this.onSubmitClicked.bind(this);
    }
    onDayChange(value) {
        this.setState({ birthDay: value });
    }
    onMonthChange(value) {
        this.setState({ birthMonth: value });
    }
    onSubmitClicked() {
        if (this.state.birthDay === 0) {
            message.warn("Please select your birth day.");
        } else if (this.state.birthMonth === 0) {
            message.warn("Please select your birth month.");
        } else {
            let self = this;
            this.setState({ submitButton: <Icon style={{ color: "#61dafb", fontSize: "32pt" }} type="loading" />, disabled: true });
            updateUserBirthday(this.props.UserStore.user._id, this.props.AuthStore.userAuth.auth.accessToken, this.state.birthDay, this.state.birthMonth).then(() => {
                self.props.UserStore.refreshUser(this.props.AuthStore.userAuth.auth.accessToken);
            })
        }
    }
    render() {
        return (
            <div className="AppFont" style={{ 
            backgroundColor: "rgba(255, 255, 255, 0.95)", 
            padding: "40px 60px",
            borderRadius: "8px",
            boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
            maxWidth: "800px",
            margin: "0 auto"
            }}>
            <h1 style={{ 
                color: "#2c3e50", 
                fontSize: "32px",
                marginBottom: "20px",
                fontWeight: "600"
            }}>Welcome to list.gifts!</h1>
            <p style={{ 
                color: "#34495e", 
                fontSize: "18px",
                lineHeight: "1.6",
                marginBottom: "30px"
            }}>To get the most out of list.gifts please upload a custom profile image in the settings drawer and input your birth day and month below.</p>
            <div style={{ marginBottom: "20px" }}>
                <span style={{ 
                color: "#2c3e50", 
                fontSize: "16px",
                marginRight: "10px"
                }}>Birth Day </span>
                <InputNumber 
                disabled={this.state.disabled} 
                onChange={this.onDayChange} 
                min={1} 
                max={31} 
                size="large" 
                />
            </div>
            <div style={{ marginBottom: "30px" }}>
                <span style={{ 
                color: "#2c3e50", 
                fontSize: "16px",
                marginRight: "10px"
                }}>Birth Month </span>
                <InputNumber 
                disabled={this.state.disabled} 
                onChange={this.onMonthChange} 
                min={1} 
                max={12} 
                size="large" 
                />
            </div>
            <p style={{ 
                color: "#7f8c8d", 
                fontSize: "14px",
                marginBottom: "20px"
            }}>By using this site you agree to not hold the creator responsible in the case of any lost or stolen data. Do not put sensitive data on this website.</p>
            {this.state.submitButton}
            </div>
        )
    }
}
export default WelcomeModal;